import React from "react";
import { Badge } from "react-bootstrap";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const PROJECT_STATUS = {
  OK: "OK",
  EXCEEDED: "Exceeded"
};

const ProjectRow = ({ project, isExpanded, onToggle }) => {
  const { t } = useTranslation();
  const isExceeded = project.status === PROJECT_STATUS.EXCEEDED;
  const statusLabel = isExceeded 
    ? t('components.planningTab.table.status_exceeded') 
    : t('components.planningTab.table.status_ok');

  return (
    <tr 
      className="fw-bold border-top" 
      onClick={onToggle} 
      style={{ cursor: "pointer" }}
    >
      <td className="px-4 py-3">
        <span className="me-2 txt-subtle" style={{ fontSize: "0.75rem" }}>
          {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
        </span>
        <span className="txt-brand me-2">●</span> {project.name}
        {project.resources?.length > 0 && (
          <span className="txt-subtle fw-normal ms-2" style={{ fontSize: "0.8rem" }}>
            ({project.resources.length === 1 
              ? t('components.planningTab.table.person_count', { count: project.resources.length }) 
              : t('components.planningTab.table.person_count_plural', { count: project.resources.length })
            })
          </span>
        )}
      </td>
      <td className="text-center">
        {project.allocated_eti?.toFixed(2)} / {project.total_eti?.toFixed(2)}
      </td>
      <td className="text-end px-4">
        <Badge 
          bg={!isExceeded ? "success" : "danger"} 
          className="fw-normal"
          style={{ backgroundColor: !isExceeded ? 'var(--success-green)' : 'var(--danger-red)' }}
        >
          {statusLabel}
        </Badge>
      </td>
      <td></td> 
    </tr>
  );
};

export default ProjectRow;